import { addDisplayName, flowMax, addProps } from 'ad-hok'
import { FC, ReactElement } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

import { OnboardingHeader } from './OnboardingHeader'

const SIDE_PADDING = 24
const useStyles = createUseStyles({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    color: '#232323',
    position: 'relative',
  },
})

interface Props {
  title: string | ReactElement
  subtitle?: string
  className?: string
  headerClassName?: string
}

export const OnboardingPage: FC<Props> = flowMax(
  addDisplayName('OnboardingPage'),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ title, subtitle, classes, className, headerClassName, children }) => (
    <div className={cx(classes.container, className)}>
      <OnboardingHeader
        title={title}
        subtitle={subtitle}
        className={headerClassName}
      />
      {children}
    </div>
  )
)
